import React from "react";
import { TableCell } from "@mui/material";

type Props = {
  headItems: { [key: string]: string };
};

function SimpleTableHeader({ headItems }: Props): JSX.Element {
  return (
    <>
      {Object.keys(headItems || {}).map((item) => (
        <TableCell key={item}>{headItems[item]}</TableCell>
      ))}
    </>
  );
}
export default SimpleTableHeader;
